import {useSavStore} from "@/store/savStore";
import {useFurnitureStorage} from "@/store/furnitureStorageStore";

export const pluginRootStore = {
  actions: {
    furnitureStorageActions() {
      return useFurnitureStorage();
    },
    savActions() {
      return useSavStore();
    },
  },
};
